import { Paper } from "@mui/material";
import { ConfirmationNumber, Savings } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { NodeEnv } from "@dzambalaorg/constants";
import { List } from "@dzambalaorg/ui-kit";

const data = [
  { text: "pages.breed.breeds.title", link: "/breed/breeds", icon: <Savings /> },
  { text: "pages.breed.history.title", link: "/breed/history", icon: <ConfirmationNumber /> },
];

export const BreedSection = () => {
  const isProd = process.env.NODE_ENV === NodeEnv.production;

  if (isProd) {
    return null;
  }

  return (
    <Paper sx={{ mb: 2 }}>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.mechanics.breed" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </Paper>
  );
};
